<template>
  <div class="pmc-right">
    <h1>
      Login <span>DecastID</span>
    </h1>
    <form @submit.prevent="handleSubmit" class="mt-8">
      <div class="flex flex-col">
        <div class="flex flex-row">
          <div class="flex flex-col flex-1 mr-2">
            <label>First name</label>
            <input v-model="firstName" type="test" placeholder="John" />
            <p v-if="firstNameError" class="text-red-500 text-xs mt-1 font-mono">{{ firstNameError }}</p>
          </div>
          <div class="flex flex-col flex-1">
            <label>Last name</label>
            <input v-model="lastName" type="test" placeholder="Smith" />
            <p v-if="lastNameError" class="text-red-500 text-xs mt-1 font-mono">{{ lastNameError }}</p>
          </div>
        </div>
        <div class="flex flex-row mt-4">
          <div class="flex flex-col flex-1 mr-2">
            <label>Email</label>
            <input v-model="email" type="email" placeholder="example@email.com" />
            <p v-if="emailError" class="text-red-500 text-xs mt-1 font-mono">{{ emailError }}</p>
          </div>
          <div class="flex flex-col flex-1">
            <label>Password</label>
            <div class="password-div-wrapper">
              <input id="loginPassword" v-model="password" :type="passwordInputType" name="password"
                placeholder="password" autocomplete="off" />
              <span class="toggle-password flex items-center justify-between px-2" @click="togglePasswordVisibility">
                <EyeVisible v-if="isPasswordVisible" />
                <EyeHide v-else />
              </span>
            </div>
            <p v-if="passwordError" class="text-red-500 text-xs mt-1 font-mono">{{ passwordError }}</p>
          </div>
        </div>
      </div>
      <div class="checkbox mt-8 flex items-center">
        <input type="checkbox" id="checkbox" v-model="isTermsConditionAccepted" class="custom-checkbox" />
        <label class="font-medium custom-checkbox-label" for="checkbox">I agree to the Decast
          <span class="underline">
            <a href="#" class="underline"> User Agreement</a>
          </span>
          and
          <span class="underline"><a href="/privacy" class="underline"> Privacy Policy</a></span>
        </label>
      </div>
      <button class="mt-8" type="submit">
        Create Account
      </button>
    </form>

    <div class="flex items-center gap-2 text-gray-400 font-mono text-sm mt-8">
      <div class="sep-line flex-grow h-px bg-gray-600"></div>
      <div class="sep-line-label">OR</div>
      <div class="sep-line flex-grow h-px bg-gray-600"></div>
    </div>

    <!-- OAuth Buttons -->
    <div class="flex flex-wrap justify-center gap-4 mt-8 mb-8">
      <GoogleLogin />
      <MetamaskLogin />
      <DidsLogin />
    </div>
  </div>
</template>

<script>
// import { ref } from 'vue'
import EyeHide from "@/decast/icons/EyeHide.vue";
import EyeVisible from "@/decast/icons/EyeVisible.vue";
import GoogleLogin from "@/decast/components/v2auth/social-logins/GoogleLogin.vue";
import MetamaskLogin from "@/decast/components/v2auth/social-logins/MetamaskLogin.vue";
import DidsLogin from "@/decast/components/v2auth/social-logins/DidsLogin.vue";

export default {
  data() {
    return {
      email: '',
      password: '',
      firstName: '',
      lastName: '',
      emailError: '',
      passwordError: '',
      twoFactorToken: '',
      firstNameError: '',
      lastNameError: '',
      isPasswordVisible: false,
      checkbox_remember_me: false,
      isTermsConditionAccepted: false,
    };
  },
  components: {
    EyeHide,
    EyeVisible,
    GoogleLogin,
    MetamaskLogin,
    DidsLogin,
  },
  mounted() {
    document.getElementById('loading-bg-transparent').style.display = 'none';
  },
  computed: {
    passwordInputType() {
      return this.isPasswordVisible ? 'text' : 'password';
    },
  },
  methods: {
    togglePasswordVisibility() {
      this.isPasswordVisible = !this.isPasswordVisible;
    },
    navigateToPassword() {
      this.$router.push('/resetPassword');
    },
    navigateToSignUp() {
      this.$router.push('/v2signup');
    },
    handleSubmit() {
      if (!this.firstName) {
        this.firstNameError = 'First name is required.'
        return;
      }
      if (!this.lastName) {
        this.lastNameError = 'Last name is required.'
        return;
      }
      if (!this.email) {
        this.emailError = 'Email is required.'
        return;
      }
      if (!this.password) {
        this.passwordError = 'Password is required.'
        return;
      }
      if (!this.isTermsConditionAccepted) {
        this.$vs.notify({
          title: 'Action required!',
          text: 'Please accept Term & Condition',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger',
        });
        return;
      }
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
      if (!emailRegex.test(this.email)) {
        this.emailError = 'Enter a valid email address.'
        return;
      }
      this.emailError = '';
      this.passwordError = '';
      this.firstNameError = '';
      this.lastNameError = '';
      this.registerUserJWt();
    },
    registerUserJWt() {
      document.getElementById('loading-bg-transparent-title').innerText = '👨‍💻Creating decast account';
      document.getElementById('loading-bg-transparent').style.display = 'flex';
      const payload = {
        userDetails: {
          firstName: this.firstName,
          lastName: this.lastName,
          email: this.email,
          password: this.password,
        },
        notify: this.$vs.notify,
      };
      this.$store
        .dispatch('auth/v2registerUser', payload)
        .then((response) => {
          // console.log("Full response:", response);       // You'll see status, headers, etc.
          // console.log("response.data:", response.data);  // This will be undefined
          this.$vs.notify({
            title: 'Registration Successful',
            text: 'You have successfully registered!',
            iconPack: 'feather',
            icon: 'icon-check-circle',
            color: 'success',
          });
          document.getElementById('loading-bg-transparent').style.display = 'none';
          this.$router.push('/v2login');
        }).catch((error) => {
          console.log("error", error.response);

          const errors = error.response?.data?.errors;
          let title = "Registration Failed";
          let text = "Something went wrong";

          if (errors) {
            if (typeof errors === "object" && !Array.isArray(errors)) {
              const firstKey = Object.keys(errors)[0];
              const firstValue = errors[firstKey];

              title = firstKey.charAt(0).toUpperCase() + firstKey.slice(1);
              text = Array.isArray(firstValue) ? firstValue[0] : String(firstValue);
            } else if (typeof errors.message === "string") {
              text = errors.message;
            }
          }

          document.getElementById('loading-bg-transparent').style.display = 'none';
          this.$vs.notify({
            title: 'Registration Failed!',
            text: text,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger',
          });
        });
    },
  }
}
</script>

<style scoped>
*:not(i) {
  /* font-family: 'Karla', sans-serif !important; */
  font-family: 'Rethink Sans' !important;
}

button:disabled {
  opacity: 0.5;
  cursor: not-allowed !important;
}

#checkbox {
  width: unset !important;
  margin-top: 0px !important;
  margin-right: 10px !important;
  width: 16px !important;
  height: 16px !important;
  cursor: pointer;
}

.pmc-right {
  position: relative;
  overflow: hidden;
  width: 80%;
  height: 100%;
  padding: 70px 70px 0px 70px;
}

.pmc-right p {
  color: #FFFFFF;
}

.pmc-right h1 {
  color: #FFFFFF;
  font-size: 40px;
  line-height: 120%;
}

.pmc-right h1 span {
  color: #D7DF23;
}

.pmc-right .pmc-right-p1 {
  color: #BCBCBC;
  font-size: 14px;
  margin-top: 10px;
  margin-bottom: 24px;
  cursor: pointer;
}

.pmc-right label {
  font-size: 14px;
  color: #FFFFFF;
}

.pmc-right input {
  background: #15161F;
  border: 1px solid #444551;
  color: #FFFFFF;
  padding: 0.75rem !important;
  border-radius: 8px !important;
  width: 100% !important;
  outline: 2px solid transparent !important;
  outline-offset: 2px !important;
  margin-top: 6px;
}

.pmc-right button {
  background: #D7DF23;
  border: 1px solid #D7DF23;
  color: #000000;
  padding: 0.75rem;
  border-radius: 12px;
  width: 100%;
  outline: 2px solid transparent;
  outline-offset: 2px;
  cursor: pointer;
  transition: transform 0.05s ease-in-out;
}

.pmc-right button:active {
  transform: scale(0.99);
}

.password-div-wrapper {
  margin-top: 6px;
  position: relative;
}

.password-div-wrapper input {
  margin-top: 6px;
  margin-top: 0px;
}

.password-div-wrapper span {
  position: absolute;
  right: 0;
  top: 0;
  bottom: 0;
  cursor: pointer;
}

.check-box-label {
  color: #BCBCBC;
  font-size: 12px;
}

.sep-line {
  background-color: #444551;
  opacity: 0.5;
}

.sep-line-label {
  color: #FFFFFF50;
  background-color: #1B1D29;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 5px;
}

p.text-lime-400 {
  color: #D7DF23;
  display: inline-block;
  margin-top: 12px;
}

@media (max-width: 1024px) {
  .pmc-right {
    width: 100%;
    padding: 70px 40px;
  }
}

@media (max-width: 768px) {}

@media (max-width: 480px) {
  .pmc-right {
    padding: 20px;
  }
}
</style>
